class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.heroAnimation();
    this.bnrModal();
    new PriceTab('js-price-table');

    // Hero Swiper
    if (document.querySelector('.js-hero-swiper')) {
      new Swiper('.js-hero-swiper', {
        slidesPerView: 1.5,
        loop: true,
        centeredSlides: true,
        speed: 800,
        loopAdditionalSlides: 10,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      });
    }

    if (document.querySelector('.js-support-swiper')) {
      new Swiper('.js-support-swiper', {
        loop: true,
        loopAdditionalSlides: 2,
        effect: "cards",
        slidesPerView: 1,
        grabCursor: true,
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        cardsEffect: {
          rotate: true,
          perSlideRotate: 25,
          perSlideOffset: 35,
        },
      });
    }

    // Flow Swiper
    if (document.querySelector('.js-flow-swiper')) {
      new Swiper('.js-flow-swiper', {
        slidesPerView: 1.25,
        centeredSlides: true,
        speed: 600,
        navigation: {
          nextEl: '.js-flow-next',
          prevEl: '.js-flow-prev',
        },
        pagination: {
          el: '.js-flow-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + String(index + 1).padStart(2) + '</span>';
          },
        },
      });
    }

  }

  bnrModal() {
    const modal = document.getElementById('js-bnr-modal');
    if (!modal) return;
    // overflow-clip の祖先要素に clipping されないよう body 直下へ移動
    document.body.appendChild(modal);

    const show = () => {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
    };

    const close = () => {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    };

    setTimeout(show, 3000);
    modal.querySelector('.js-modal-close').addEventListener('click', close);
    modal.querySelector('.js-modal-overlay').addEventListener('click', close);
  }

  heroAnimation() {
    if (!document.querySelector('.js-hero-logo')) return;

    const tl = gsap.timeline();

    // 背景装飾: じわっとフェードイン
    tl.fromTo('.js-hero-bg',
      { opacity: 0 },
      { opacity: 1, duration: 2, ease: 'power1.inOut' },
      0
    )

    // ロゴ: 上から落ちてくる + わずかにバウンス
    .fromTo('.js-hero-logo',
      { opacity: 0, y: -32, scale: 0.88 },
      { opacity: 1, y: 0, scale: 1, duration: 1.1, ease: 'back.out(1.6)' },
      0.3
    )

    // ヒーロースワイパー: 軽くズームアウトしながら出現（シネマティック）
    .fromTo('.js-hero-swiper-wrap',
      { opacity: 0, scale: 1.06, y: 16 },
      { opacity: 1, scale: 1, y: 0, duration: 1.4, ease: 'power3.out' },
      0.6
    )

    // イントロテキスト: 下からせり上がる
    .fromTo('.js-hero-intro',
      { opacity: 0, y: 36 },
      { opacity: 1, y: 0, duration: 1.1, ease: 'power3.out' },
      1.2
    );
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class Drawer {
  constructor(triggerClass) {
    this.triggerClass = triggerClass;
    if ($("." + this.triggerClass).length > 0) {
      this.event();
    }
  }

  event() {
    $('.js-drawer-trigger').on('click', () => {
      $('html').toggleClass('is-drawer');
    });

    $('.js-link-close').on('click', () => {
      $('html').removeClass('is-drawer');
    });
  }
}

class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class PriceTab {
  constructor(el) {
    this.root = document.querySelector('.' + el);
    if (!this.root) return;
    this.event();
  }

  event() {
    const tabs = this.root.querySelectorAll('[data-price-tab]');
    const panels = this.root.querySelectorAll('[data-price-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.priceTab;

        tabs.forEach((item) => {
          const isActive = item.dataset.priceTab === target;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.pricePanel === target;
          panel.classList.toggle('hidden', !isActive);
          panel.hidden = !isActive;
        });
      });
    });
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}

(() => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let drawer = new Drawer('js-drawer-trigger');
  let top = new Top('p-top');
})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});
